import { bianka, BIANKA_ACTIVITY_TYPES } from '@fiverr-private/obs';
import { Impression, Click, ClickType, ElementType } from '@fiverr-private/bianka_js';
import { getContext } from '@fiverr-private/fiverr_context';
import { BIGQUERY_REVAMP_PAGE_NAME } from '../constants';

interface ReportImpression {
    eventName: string;
    componentName: string;
    componentText?: string;
}

export const reportImpression = ({ eventName, componentName, componentText }: ReportImpression) => {
    const { pageCtxId } = getContext();

    bianka.reportActivity<Impression>({
        event: {
            type: eventName,
            page: {
                name: BIGQUERY_REVAMP_PAGE_NAME,
                ctxId: pageCtxId,
            },
            component: {
                impId: Date.now().toString(),
                level: 1,
                isLeaf: false,
                positionInParent: 1,
                numberOfElements: 1,
                sizeInParent: 1,
                visibleThroughScroll: true,
                name: componentName,
                ...(componentText ? { text: componentText } : {}),
            },
        },
        type: BIANKA_ACTIVITY_TYPES.IMPRESSION,
    });
};

interface ReportClick {
    eventName: string;
    elementType: ElementType;
    elementName: string;
    elementText?: string;
    clickType?: ClickType;
    position?: number;
}

export const reportClick = ({
    eventName,
    elementType,
    elementName,
    position,
    elementText,
    clickType = ClickType.UNSPECIFIED,
}: ReportClick) => {
    const { pageCtxId } = getContext();

    bianka.reportActivity<Click>({
        event: {
            type: eventName,
            page: {
                name: BIGQUERY_REVAMP_PAGE_NAME,
                ctxId: pageCtxId,
            },
            element: {
                name: elementName,
                type: elementType,
                ...(position ? { position: { value: position } } : {}),
                ...(elementText ? { text: { value: elementText } } : {}),
            },
            clickType,
        },
        type: BIANKA_ACTIVITY_TYPES.CLICK,
    });
};
